import { render, staticRenderFns } from "./ItemCodeQuery.vue?vue&type=template&id=dd6e8ce2&scoped=true&"
import script from "./ItemCodeQuery.vue?vue&type=script&lang=js&"
export * from "./ItemCodeQuery.vue?vue&type=script&lang=js&"
import style0 from "./ItemCodeQuery.vue?vue&type=style&index=0&id=dd6e8ce2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6e8ce2",
  null
  
)

export default component.exports